<template>
    <div id="app">
        <div class="header">
            <div style="float: left">
                <el-button @click="getData(1)" :class="allot_id==1 ? 'btn_active' : 'btn_default'" size="mini">会员分配
                </el-button>
                <el-button @click="getData(0)" :class="allot_id==0 ? 'btn_active' : 'btn_default'" type="warning"
                           size="mini" style="margin-right: 5px;">潜客分配
                </el-button>
                <span>已选({{checkNum}})</span>
                <span class="btna btn-xs" @click="allot">分配</span>
            </div>

            <div style="float: left;margin-left: 300px;">
                <el-row style="width: 150px;">
                    <el-col :span="24">
                        <el-input placeholder="请输入姓名" v-model="search" class="input-with-select" size="small" @keyup.enter.native="getData(allot_id)">
                            <el-button slot="append" type="warning" size="small" style="
								background:#7c71bf;color: #fff;border: 1px solid #7c71bf;border-bottom:0;border-radius: 0  4px 4px 0"
                                       icon="el-icon-search" @click="getData(allot_id)"></el-button>
                        </el-input>
                    </el-col>
                </el-row>
            </div>
            <span class="btna btn-xs" v-if="allot_id == 1" @click="del_vip">彻底删除</span>
            <span class="btna btn-xs" v-if="allot_id == 0" @click="del_qk">彻底删除</span>
            <div class="right">
                选择前<select v-model="select_Val" name="">
                <option value="">请选择</option>
                <option v-for="item in option2" :value="item.value">
                    {{item.name}}
                </option>
            </select>
                <span class="btna btn-xs" @click="allot_num">分配</span>
            </div>
        </div>
        <!--选择销售弹出框1-->
        <el-dialog
                title="提示"
                :visible.sync="DialogVisible"
                width="25%">
            <div style="margin-bottom: 20px;margin-left: 5px;">请为已选中的 {{checkNum}} 个客户分配负责销售</div>
            <span style="color: red;vertical-align: middle;">*</span>
            <label>选择销售：</label>
            <select name="" v-model="sell_name" style="width: 250px;">
                <option value="">请选择</option>
                <option v-for="(item,index) in options" :value="item.user_id">
                    {{ item.username }}
                </option>
            </select>
            <span slot="footer" class="dialog-footer">
		    <el-button @click="DialogVisible = false" size="mini">取 消</el-button>
		    <el-button @click="confirm_allot" type="warning" size="mini">确 定</el-button>
		  </span>
        </el-dialog>

        <!--选择销售弹出框2-->
        <el-dialog
                title="提示"
                :visible.sync="DialogVisible1"
                width="30%">
            <div style="margin-bottom: 20px;margin-left: 5px;">请为已选中的 {{select_Val}} 个客户分配负责销售</div>
            <span style="color: red;vertical-align: middle;">*</span>
            <label>选择销售：</label>
            <select name="" v-model="sell_name1" style="width: 250px;">
                <option v-for="(item,index) in options" :value="item.user_id">
                    {{ item.username }}
                </option>
            </select>
            <span slot="footer" class="dialog-footer">
		    <el-button @click="DialogVisible1 = false" size="mini">取 消</el-button>
		    <el-button @click="confirm_allot1" type="warning" size="mini">确 定</el-button>
		  </span>
        </el-dialog>

        <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                border
                @selection-change="handleSelectionChange">
            <el-table-column
                    type="selection"
                    width="40">
            </el-table-column>
            <el-table-column
                    label="状态"
                    prop="gj_type"
                    width="100">
            </el-table-column>
            <el-table-column
                    width="90"
                    prop="baobao_name"
                    label="会员姓名">
            </el-table-column>
            <el-table-column
                    prop="name"
                    width="90"
                    label="家长姓名">
            </el-table-column>

            <el-table-column
                    prop="phone"
                    width="110"
                    label="电话">
            </el-table-column>

            <el-table-column
                    width="100"
                    prop="baobao_birthday"
                    label="会员生日">
            </el-table-column>
            <el-table-column
                    width="100"
                    prop="username"
                    label="采单人">
            </el-table-column>
            <el-table-column
                    width="100"
                    prop="create_time"
                    label="采单日期">
            </el-table-column>
            <el-table-column label="跟进记录">
                <template slot-scope="scope">
                    <span style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">{{ scope.row.neirong ? scope.row.neirong : '--' }}</span>
                </template>
            </el-table-column>
        </el-table>

        <div class="footer">
            <el-pagination
                    @current-change="handleCurrentChange"
                    background
                    prev-text="上一页"
                    next-text="下一页"
                    :current-page="currentPage"
                    :page-size="10"
                    layout="prev, pager, next"
                    :total="totalNum">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                // 表格数据
                checkNum: 0,
                token: '',
                tableData: [],
                multipleSelection: [],
                now_page: 1,
                totalNum: 0,
                userid: [],
                // 分页
                currentPage: 1,
                select_Val: '',
                options: [],
                option2: [
                    {name: '100条', value: 100},
                    {name: '200条', value: 200},
                    {name: '500条', value: 500}
                ],
                // 弹出框
                DialogVisible: false,
                DialogVisible1: false,
                sell_name: '',
                sell_name1: '',
                pageone: 10,
                allot_id: 0,
                search:''
            }
        },
        created() {
            let that = this
            that.token = that.$cookies.get('token');
            //表格数据
            this.getData();

            //顾问数据
            this.selectVal();
        },
        methods: {
            del_qk(){
                let that = this;
                if (that.checkNum == 0) {
                    that.$message.error('请先选择要删除的客户')
                    return;
                }
                that.$confirm('此操作将删除 ' + that.checkNum + '个客户, 是否确认?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //这里请求ajax
                    $.ajax({
                        url: process.env.apiUrl +'saas/qk/del_qk',
                        type: 'post',
                        data: {
                            user_id: that.userid,
                            token: that.token
                        },
                        dataType: 'json',
                        success: function(data) {
                            if(data.status == 1){
                                that.$message.success(data.msg)
                                that.getData();
                            }
                        }
                    })
                }).catch(() => {
                });
            },
            del_vip(){
                let that = this;
                if (that.checkNum == 0) {
                    that.$message.error('请先选择要删除的客户')
                    return;
                }
                that.$confirm('此操作将删除 ' + that.checkNum + '个客户, 是否确认?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //这里请求ajax
                    $.ajax({
                        url: process.env.apiUrl +'saas/qk/del_vip',
                        type: 'post',
                        data: {
                            user_id: that.userid,
                            token: that.token
                        },
                        dataType: 'json',
                        success: function(data) {
                            if(data.status == 1){
                                that.$message.success(data.msg)
                                that.getData();
                            }
                        }
                    })
                }).catch(() => {
                });
            },
            //表格数据
            getData(i) {
                if (i) {
                    this.allot_id = i
                } else {
                    this.allot_id = 0
                }

                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/qk/shu',
                    type: 'post',
                    data: {
                        p: that.now_page,
                        token: that.token,
                        search:that.search,
                        type: that.allot_id
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.tableData = data.data
                            //总条数
                            that.totalNum = Number(data.map.count)
                            //当前页数
                            that.now_page = Number(data.map.page)
                            that.pageone = Number(data.map.pageone)
                        } else {
                            that.$message.error(data.msg)
                        }
                        that.search = '';
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //分页
            handleCurrentChange(val) {
                this.now_page = val
                this.getData(this.allot_id)
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.checkNum = val.length;
                var arr = []
                for (var i = 0; i < val.length; i++) {
                    arr.push(val[i].user_id);
                }
                arr = arr.toString()
                this.userid = arr
            },
            // 销售人员列表
            selectVal() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/qk/yxlb',
                    type: 'post',
                    data: {
                        token: that.token
                    },
                    success: function (data, status) {
                        that.options = data.data
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            // 分配1
            allot() {
                if (this.checkNum != 0) {
                    this.DialogVisible = true
                } else {
                    this.$message.error('请先选择要分配的客户')
                }
            },
            confirm_allot() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/qk/fenpei',
                    type: 'post',
                    data: {
                        user_id: that.userid,
                        xiaoshou: that.sell_name,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.DialogVisible = false
                            that.$message.success(data.msg)
                            that.getData();
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            // 按数量分配
            allot_num() {
                if (this.select_Val == '') {
                    this.$message.error('请先选择要分配的数量')
                } else {
                    this.DialogVisible1 = true
                }
            },
            confirm_allot1() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/Qk/fenpeitwo',
                    type: 'post',
                    data: {
                        user_num: that.select_Val,
                        xiaoshou: that.sell_name1,
                        type: that.allot_id,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.$message.success(data.msg)
                            that.DialogVisible1 = false
                            that.getData()
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })

            }
        }
    }
</script>

<style lang="less" scoped="scoped">
    .btn_active {
        background-color: #E6BE8A;
        border-color: #E6BE8A;
        color: white;
    }

    .btn_default {
        border: 1px solid #dcdfe6;
        background-color: #fff;
        color: gray;
    }

    .text_hidden {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    #app {
        padding: 10px;
    }

    .header {
        padding: 10px;
        .btna {
            border: 0;
            display: inline-block;
            text-align: center;
            border-radius: 4px;
            line-height: 25px;
            color: #fff;
            background-color: #E6BE8A;
            cursor: pointer;
            margin-left: 5px;
            padding: 1px 12px;
        }
        .right {
            float: right;
        }
        select {
            padding: 1px;
            margin-left: 3px;
        }
    }

    .footer {
        margin-top: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/genjin/minuta.vue